module.exports = __webpack_public_path__ + "static/img/WestCoastFever.2448e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WestCoastFever.png
// module id = 6wQr
// module chunks = 1